// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1lTf_","topBottomGutter":"Layout_topBottomGutter__3ZOdd"};